function devtricker_showPostToast(toastElement) {

    const offcanvasBody = document.querySelector('.container');

    if (offcanvasBody) {
        offcanvasBody.appendChild(toastElement);
        
        const toast = new bootstrap.Toast(toastElement);
        toast.show();
        
        setTimeout(() => {
            toastElement.remove();
        }, 2000);
    }
}